import { render } from "./DefaultBarChart.vue?vue&type=template&id=2c434628"
import script from "./DefaultBarChart.vue?vue&type=script&lang=js"
export * from "./DefaultBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DefaultBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c434628"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c434628', __exports__)) {
    api.reload('2c434628', __exports__)
  }
  
  module.hot.accept("./DefaultBarChart.vue?vue&type=template&id=2c434628", () => {
    api.rerender('2c434628', render)
  })

}


export default __exports__